var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import * as d3 from 'd3';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import { cuppingDescriptorHierarchy } from '../,,/../../../constants/cuppingDescriptorValues';
import { cuppingDescriptorWithAncestor } from '../,,/../../../utils/cuppingComment';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n\n  g {\n    .active {\n      opacity: 1;\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n"], ["\n  text-align: center;\n\n  g {\n    .active {\n      opacity: 1;\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n"])));
var CuppingDescriptorsChart = function (_a) {
    var descriptors = _a.descriptors, _b = _a.size, size = _b === void 0 ? 260 : _b;
    var radius = size / 2;
    var svgRef = React.useRef(null);
    var _c = React.useState('0,0,0,0'), viewBox = _c[0], setViewBox = _c[1];
    var partition = function (data) {
        return d3.partition().size([2 * Math.PI, radius])(d3.hierarchy(data).sum(function (d) { return (d === null || d === void 0 ? void 0 : d.value) || 0; }));
    };
    var arc = d3
        .arc()
        .startAngle(function (d) { return d.x0; })
        .endAngle(function (d) { return d.x1; })
        .padAngle(function (d) { return Math.min((d.x1 - d.x0) / 2, 0.005); })
        .padRadius(radius / 2)
        .innerRadius(function (d) { return d.y0; })
        .outerRadius(function (d) { return d.y1 - 1; });
    var getAutoBox = function () {
        if (!svgRef.current)
            return '';
        var _a = svgRef.current.getBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return [x, y, width, height].toString();
    };
    var root = partition(Object.assign(cuppingDescriptorHierarchy));
    var activeCuppingDescriptorWithAncestor = React.useMemo(function () {
        return descriptors.map(function (descriptor) {
            return cuppingDescriptorWithAncestor.find(function (_a) {
                var name = _a.name;
                return name === descriptor;
            });
        });
    }, [descriptors]);
    React.useEffect(function () { return setViewBox(getAutoBox()); }, [setViewBox, activeCuppingDescriptorWithAncestor]);
    if (!activeCuppingDescriptorWithAncestor.some(function (item) { return item; }))
        return null;
    return (React.createElement(Wrapper, { className: "descriptors_chart" },
        React.createElement("svg", { width: size, height: size, ref: svgRef, viewBox: viewBox },
            React.createElement("g", null, root
                .descendants()
                .filter(function (_a) {
                var depth = _a.depth;
                return depth;
            })
                .map(function (d, i) {
                var isActive = activeCuppingDescriptorWithAncestor.some(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.name) === d.data.name ||
                        ((item === null || item === void 0 ? void 0 : item.ancestor) &&
                            (item === null || item === void 0 ? void 0 : item.ancestor[d.depth - 1]) === d.data.name);
                });
                return isActive ? (React.createElement(Tooltip, { title: d.data.name, enterTouchDelay: 100 },
                    React.createElement("path", { key: "".concat(d.data.name, "-").concat(i), fill: d.data.bgColor, d: arc(d) || undefined, className: 'active' },
                        React.createElement("text", null, d.data.name)))) : (React.createElement("path", { key: "".concat(d.data.name, "-").concat(i), fill: '#E5E8EB', d: arc(d) || undefined, className: 'inactive' },
                    React.createElement("text", null, d.data.name)));
            })))));
};
export default CuppingDescriptorsChart;
var templateObject_1;
